var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-592.5 -904.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.074,911.057h-2.131v-1.475a5.082,5.082,0,0,0-10.164,0v1.475h-2.131A1.149,1.149,0,0,0,594.5,912.2v11.147a1.149,1.149,0,0,0,1.148,1.148h14.426a1.149,1.149,0,0,0,1.148-1.148V912.2A1.149,1.149,0,0,0,610.074,911.057Zm-11.311-1.475a4.1,4.1,0,0,1,8.2,0v1.475h-8.2Zm11.475,13.77a.166.166,0,0,1-.164.164H595.648a.166.166,0,0,1-.164-.164V912.2a.166.166,0,0,1,.164-.164h14.426a.166.166,0,0,1,.164.164Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.975,936.5a1.472,1.472,0,0,0-.492,2.86v2.222a.492.492,0,0,0,.984,0V939.36a1.472,1.472,0,0,0-.492-2.86Zm0,1.967a.492.492,0,1,1,.492-.492A.492.492,0,0,1,616.975,938.467Z",
    transform: "translate(-14.115 -21.508)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.ced305a641cc66256e6d05280fcdd07f.svg";
export { ForwardRef as ReactComponent };